import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";

import { init } from "echarts";
import { isEmpty, round } from "lodash";
import Color from "@/tool/color";
import Empty from "@/component/empty";
import moWelfare from "../store/wealfare";
import moIndex from "../../store";

interface IProps {}
interface IState {}

const HolidayEchangeCity = (props: IProps, state: IState) => {
  let echartdom: any = null;
  const topRef = useRef<any>(null);
  const { KeyHolidayTopList, KeyHolidayTopData } = moWelfare;
  const { isMock } = moIndex;
  const datas = KeyHolidayTopData.map((item: any) => {
    const items = item * 100;
    return items;
  });
  const render = () => {
    if (echartdom) echartdom.dispose();
    echartdom = init(topRef.current);
    const option = {
      tooltip: {
        trigger: "item",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
        formatter: (parmes: any) => {
          const htl = `
                     <p style="font-family: 'PingFang SC';
                     color:${Color.blackColor(1)};font-size:14px">${
            parmes.seriesName
          }</p>
                     <p style="margin-top:10px;display:flex;
                         justify-content: space-between;align-items: center;">
                      <span
                        style="display:inline-block;
                        width:10px;height:10px;
                        background:${Color.primary};
                        border-radius:50%;margin-right:5px">
                      </span>
                      <span style="font-family: 'PingFang SC';
                      color:${Color.blackColor(0.6)};font-size:14px">${
            parmes.name
          }</span>
                      <span style="margin:0 15px"></span>
                      <span style="font-family: 'Roboto';
                       color:${Color.blackColor(0.8)};font-size:16px">
                       ${round(parmes.value, 1)}%
                      </span>
                   </p>
                 `;
          return htl;
        },
      },
      legend: {
        data: [],
      },
      grid: {
        left: "3%",
        right: "3%",
        bottom: 30,
        top: "40px",
        containLabel: true,
      },
      yAxis: [
        {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: Color.blackColor(0.1),
              width: 1,
              type: "dashed",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.5),
            fontFamily: "Roboto",
            formatter: (val: any) => {
              return `${round(val, 1)} %`;
            },
          },
        },
      ],
      xAxis: [
        {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: Color.ccc,
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: Color.blackColor(0.85),
            fontFamily: "Roboto",
          },
          data: KeyHolidayTopList,
        },
      ],
      series: [
        {
          name: "人均福利预算",
          type: "bar",
          label: {
            show: true,
            position: "top",
            fontFamily: "Roboto",
            fontSize: 14,
            formatter: (parmes: any) => {
              return `${round(parmes.value, 1)} %`;
            },
          },
          emphasis: {
            focus: "self",
            blurScope: "coordinateSystem",
          },
          color: Color.primary,
          lineStyle: {
            color: Color.primary,
            width: 2,
          },
          itemStyle: {
            borderRadius: [2, 2, 0, 0],
          },
          barWidth: 16,
          data: datas,
        },
      ],
    };
    echartdom.setOption(option);
  };

  useEffect(() => {
    if (topRef.current) {
      render();
    }
    window.addEventListener("resize", render);
    return () => {
      window.removeEventListener("resize", render);
    };
  }, [KeyHolidayTopData, KeyHolidayTopList]);

  return (
    <section className="welfare-echange-city">
      <section
        style={{
          display: "flex",
          justifyContent: "flex-start",
          height: "26px",
        }}
      >
        <span className="sub-title">兑换城市 TOP 10</span>
      </section>
      {!isEmpty(KeyHolidayTopData) ? (
        <section
          ref={topRef}
          className="echange-pic"
          style={{
            width: "100%",
            height: "270px",
            marginBottom: 20,
            backgroundImage: isMock
              ? "url(https://file.smartsalary.cn/web-img%402.0/market/image/ismock.png)"
              : "",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
          }}
        />
      ) : (
        <Empty />
      )}
    </section>
  );
};

export default observer(HolidayEchangeCity);
